module.exports = __webpack_public_path__ + "static/media/picture.7f8fa23d.svg";